import { render } from "./DeviceDetailed.vue?vue&type=template&id=23545f8c&scoped=true"
import script from "./DeviceDetailed.vue?vue&type=script&lang=js"
export * from "./DeviceDetailed.vue?vue&type=script&lang=js"

import "./DeviceDetailed.vue?vue&type=style&index=0&id=23545f8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23545f8c"

export default script